/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'coffee': {
    width: 60,
    height: 60,
    viewBox: '0 0 60 60',
    data: '<path pid="0" d="M20 57h-2M16 57h-5a5 5 0 01-5-5v-1h42v1a5 5 0 01-5 5H22" _stroke="#000230" stroke-width="2" stroke-miterlimit="10"/><path pid="1" d="M16.446 51.001C10.831 48.06 7 42.178 7 35.4V28a1 1 0 011-1h38a1 1 0 011 1v7.4c0 6.777-3.83 12.659-9.444 15.6" _stroke="#000230" stroke-width="2" stroke-miterlimit="10"/><path pid="2" d="M43.451 46C47.078 46 56 43 56 36c0-2.761-2.148-5-4.797-5-1.81 0-3.386 1.045-4.203 2.588M37.252 23.553C38.168 23.04 39 22.125 39 21a3 3 0 00-3-3h-2.76A4.24 4.24 0 0129 13.76V13M17 14h1a3 3 0 003-3v-1M25 21a3 3 0 00-3-3h-8a2 2 0 110-4h1M10 31h11M23 31h2M27 31h2" _stroke="#000230" stroke-width="2" stroke-miterlimit="10"/><path pid="3" d="M38 46h-2v2h2v-2zM41 43h-2v2h2v-2zM43 39h-2v2h2v-2zM44 35h-2v2h2v-2z" _fill="#000230"/>'
  }
})
